import * as moment from 'moment';


export function momentDateComparator(date1: string, date2: string) {
    const date1Moment = moment(date1);
    const date2Moment = moment(date2);
    return date1Moment.diff(date2Moment);
  }